import styled from "styled-components";
import { Card, Checkbox } from "antd";

export const AnswersCard = styled(Card)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 15px;
  overflow: hidden;
  margin: 0 auto;
  .ant-card-body {
    padding: 0;
  }
`;

export const CardGrid = styled(Card.Grid)`
  width: 100%;

  @media (min-width: 768px) {
    width: 50%;
  }
`;

export const CardContent = styled.div<{ isSelected: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
  font-size: 16px;
  border: 2px solid #ccc;
  padding-left: 30px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #e6f7ff;
    border-color: #1890ff;
  }

  ${(props) =>
    props.isSelected &&
    `
    color: #1890ff;
    background-color: #e6f7ff;
    border-color: #1890ff;
  `}
`;

export const StyledCheckbox = styled(Checkbox)`
  display: block;
  margin: 8px;

  .ant-checkbox-inner {
    width: 30px;
    height: 30px;
  }
  .ant-checkbox-inner::after {
    width: 12px;
    height: 17px;
  }
`;

export const ModalInput = styled.div`
  margin-top: 16px;
  width: 100%;

  input {
    margin-bottom: 16px;
    padding: 8px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: border-color 0.3s ease;
    height: 50px;

    &:focus {
      border-color: #1890ff;
      outline: none;
      box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    }
  }
`;
